<h2 class="error-heading"><mat-icon>error</mat-icon> Error</h2>
<div class="dialog-content-center">
  <p style="white-space: pre-wrap">{{errorMessage}}</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button [mat-dialog-close]="false" color="warn">No</button>
  <button class="dialog-button" mat-raised-button [mat-dialog-close]="true" color="primary">Yes</button>
</mat-dialog-actions>
